import { memo } from 'react';
import { cn } from '@divlab/divanui';

import Img from '@UI/Img';
import Blockuote from '../Blockuote';
import useMedias from '@Hooks/useMedias';
import Sign from '../Sign';
import styles from './SingleContent.module.css';

import type { SingleContentData } from '@Pages/PageWikiArticle';
import type { FC, HTMLAttributes } from 'react';

export interface SingleContentProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  contentData: SingleContentData;
  view: 'vertical' | 'horizontal';
}

const SingleContent: FC<SingleContentProps> = (props) => {
  const { className, contentData, view, ...restProps } = props;
  const { isMobile } = useMedias();

  return (
    <div
      {...restProps}
      className={cn(
        styles.grid,
        {
          [styles.viewVertical]: view === 'vertical',
          [styles.viewHorizontal]: view === 'horizontal',
        },
        className,
      )}
    >
      <div className={styles.container}>
        {contentData.img && (
          <Img src={contentData.img} className={styles.image} cnImage={styles.cnImage} />
        )}
        <div className={styles.colContainer}>
          {contentData.sign && isMobile && <Sign className={styles.sign}>{contentData.sign}</Sign>}
          <div className={styles.col}>
            {contentData.blockquote && contentData.text ? (
              <Blockuote content={contentData.text} size='s' />
            ) : (
              contentData.text && <div className={styles.text}>{contentData.text}</div>
            )}
          </div>
        </div>
      </div>

      {contentData.sign && !isMobile && <Sign className={styles.sign}>{contentData.sign}</Sign>}
    </div>
  );
};

export default memo(SingleContent);
